<template>
  <div class="flex flex-col lg:flex-row w-full h-full mx-auto py-4 lg:p-6">
    <div class="bg-white shadow-lg rounded-lg w-12/12 lg:w-2/6 mx-4 py-4 overflow-hidden mb-4 lg:mb-0">
      <div class="h-full overflow-auto px-4">
        <div class="flex items-center gap-1 justify-end pb-4 sticky top-0 bg-white relative z-10">
          <h1 class="flex items-center gap-1 font-bold text-gray-900 px-2 py-2 leading-tight tracking-wider">
            Revisión de descargas
            <span class="rounded-full px-4 py-1 bg-gray-200">
              {{ filteredRegisters.length }}
            </span>
          </h1>
          <div class="flex-1"></div>
          <button
            aria-label="Reordenar descargas"
            class="border p-1 rounded border-gray-700"
            @click="changeFormOrder"
          >
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current"
              viewBox="0 0 24 24"
            >
              <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"/>
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </button>
        </div>

        <input
          type="text"
          v-model="search"
          placeholder="Búsqueda de descargas"
          class="w-full appearance-none border rounded py-2 px-3 mb-1 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white"
        />

        <div class="w-full flex gap-1 my-1">
          <btn-action
            v-on:click="
              (statusFilter = 'TODOS'), filteredRegisters, updateselectElement()
            "
            class="w-1/2 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilter === 'TODOS'
                ? 'border-transparent bg-selected'
                : 'bg-transparent',
            ]"
            :colorT="color_terciario"
          >
            Todos {{ filteredByAll.length }}
          </btn-action>
          <btn-action
            v-on:click="
              (statusFilter = 'NO REVISADOS'),
                filteredRegisters,
                updateselectElement()
            "
            class="w-1/2 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilter === 'NO REVISADOS'
                ? 'border-transparent bg-selected'
                : 'bg-transparent',
            ]"
            :colorT="color_terciario"
          >
            EN PROCESO {{ filteredByOpen.length }}
          </btn-action>
        </div>

        <div class="w-full flex gap-1 my-1">
          <btn-action
            v-on:click="
              (statusFilter = 'RECHAZADOS'),
                filteredRegisters,
                updateselectElement()
            "
            class="w-1/2 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilter === 'RECHAZADOS'
                ? 'border-transparent bg-selected'
                : 'bg-transparent',
            ]"
            :colorT="color_terciario"
          >
            RECHAZADOS {{ filteredByCanceled.length }}
          </btn-action>
          <btn-action
            v-on:click="
              (statusFilter = 'APROBADOS'),
                filteredRegisters,
                updateselectElement()
            "
            class="w-1/2 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilter === 'APROBADOS'
                ? 'border-transparent bg-selected'
                : 'bg-transparent',
            ]"
            :colorT="color_terciario"
          >
            APROBADOS {{ filteredByAttended.length }}
          </btn-action>
        </div>


        <div-selected-styled
          v-for="event in filteredRegisters"
          :key="event.id"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{ 'bg-selected': event.id === currentRegister.id }"
          @click="selectRegister(event)"
          :colorT="color_terciario"
        >
          <div class="flex flex-col flex-grow ml-2">
            <span
              :class="[
                event.id === currentRegister.id
                  ? 'text-gray-100'
                  : 'text-gray-900',
              ]"
              class="group-hover:text-gray-900"
              >{{ event.nombre_descarga }}</span
            >
            <span
              :class="[
                event.id === currentRegister.id
                  ? 'text-gray-100'
                  : 'text-gray-900',
              ]"
              class="group-hover:text-gray-900"
              >{{ event.fecha_solicitud | moment("DD/MM/YYYY hh:mm A") }}</span
            >
            <span
              :class="[
                event.id === currentRegister.id
                  ? 'text-gray-300'
                  : 'text-gray-700',
              ]"
              class="text-sm group-hover:text-gray-700"
              >F-{{ event.id }} {{ event.status }}</span
            >
          </div>
          <div
            v-if="event.en_pausa === true"
            class="flex self-start justify-self-end text-xs"
          >
            <div
              class="px-3 py-1 rounded-full border-2 border-blue-700 text-xs text-white bg-blue-500"
            >
              En pausa
            </div>
          </div>
        </div-selected-styled>
      </div>
    </div>

    <div class="flex flex-wrap bg-white shadow-lg rounded-lg w-12/12 lg:w-4/6 mx-4 py-8 overflow-hidden">
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full">
          <div class="flex w-full">
            <div
              class="flex flex-col w-11/12 lg:w-8/12 px-3 py-2 mx-auto my-3 bg-gray-400 rounded-lg shadow-xl"
            >
              <div class="flex items-center">
                <div class="flex items-center w-1/2 text-left text-xs">
                  <div class="flex items-center w-full text-left text-xs">
                    <div
                      v-if="currentRegister.status === 'NO REVISADO'"
                      class="px-3 py-1 rounded-full border-2 border-blue-700 text-white bg-blue-500 tracking-widest font-bold"
                    >
                      F-{{ currentRegister.id }} EN PROCESO
                    </div>
                    <div
                      v-if="currentRegister.status === 'RECHAZADO'"
                      class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                    >
                      F-{{ currentRegister.id }} {{ currentRegister.status }}
                    </div>
                    <div
                      v-if="currentRegister.status === 'EN REVISIÓN'"
                      class="px-3 py-1 rounded-full border-2 border-orange-700 text-white bg-orange-500 tracking-widest font-bold"
                    >
                      F-{{ currentRegister.id }} {{ currentRegister.status }}
                    </div>
                    <div
                      v-if="currentRegister.status === 'APROBADO'"
                      class="px-3 py-1 rounded-full border-2 border-green-700 text-white bg-green-500 tracking-widest font-bold"
                    >
                      F-{{ currentRegister.id }} {{ currentRegister.status }}
                    </div>
                    <div class="pl-2">
                      <div
                        v-if="currentRegister.activo === true"
                        class="px-3 py-1 rounded-full border-2 border-blue-700 text-white bg-blue-500 tracking-widest font-bold"
                      >
                        Activo
                      </div>
                      <div
                        v-if="currentRegister.activo === false"
                        class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                      >
                        Desactivado
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/2 text-right text-xs text-gray-900">
                  {{
                    currentRegister.fecha_solicitud
                      | moment("DD/MM/YYYY hh:mm a")
                  }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Nombre de la descarga:</span>
                </div>
                <div
                  class="w-full lg:w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentRegister.nombre_descarga }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Solicitante:</span>
                </div>
                <div
                  class="w-full lg:w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentRegister.nombre_propietario }}
                  {{ currentRegister.apellido_propietario }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Correo solicitante:</span>
                </div>
                <div
                  class="w-full lg:w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentRegister.email }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold"
                    >Descripción / Uso de información:</span
                  >
                </div>
                <div
                  class="w-full lg:w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentRegister.descripcion }}
                </div>
              </div>

              <template v-if="currentRegister.file_path">
                <span><br />haga click en el icono para descargar<br /></span>
                <div
                  class="flex flex-wrap w-full item-center justify-center px-3 mb-6 md:mb-0"
                >
                  <a
                    :href="replaceURL(currentRegister.file_path)"
                    :download="`${currentRegister.id}-${currentRegister.nombre_descarga}`"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="60"
                      width="60"
                    >
                      <path
                        d="M7 40Q5.85 40 4.925 39.075Q4 38.15 4 37V11Q4 9.85 4.925 8.925Q5.85 8 7 8H21L24 11H41Q42.15 11 43.075 11.925Q44 12.85 44 14V37Q44 38.15 43.075 39.075Q42.15 40 41 40ZM32 37H41Q41 37 41 37Q41 37 41 37V14Q41 14 41 14Q41 14 41 14H32V18.6H36.6V23.2H32V27.8H36.6V32.4H32ZM7 37H27.4V32.4H32V27.8H27.4V23.2H32V18.6H27.4V14H22.75L19.75 11H7Q7 11 7 11Q7 11 7 11V37Q7 37 7 37Q7 37 7 37ZM7 14V11Q7 11 7 11Q7 11 7 11V37Q7 37 7 37Q7 37 7 37Q7 37 7 37Q7 37 7 37V14Q7 14 7 14Q7 14 7 14Z"
                      />
                    </svg>
                  </a>
                </div>
              </template>
            </div>
          </div>
          <div v-if="category != 'ADMINISTRADOR'">
            <button
              v-if="
                currentRegister.status === 'NO REVISADO' ||
                (currentRegister.status === 'EN REVISIÓN' &&
                  email === currentRegister.email_curador)
              "
              v-on:click="updateStatusModal('APROBADO', 'APROBAR')"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >
              APROBAR
            </button>
            <button
              v-if="
                currentRegister.status === 'NO REVISADO' ||
                (currentRegister.status === 'EN REVISIÓN' &&
                  email === currentRegister.email_curador)
              "
              v-on:click="updateStatusModal('RECHAZADO', 'RECHAZAR')"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >
              RECHAZAR
            </button>
          </div>
        </div>
      </div>
    </div>

    <raising-modal
      :showing="showRaisingModal"
      @close="showRaisingModal = false"
      @updateAllRaising="fetchRegisters"
    ></raising-modal>
  </div>
</template>

<script>
import urlMixin from "@/mixins/urlMixin";
import AlertDialog from "./AlertDialog";

import RaisingModal from "./RaisingModal";

import moment from "moment";


import L from "leaflet";

import { LMap, LMarker, LGeoJson, LTileLayer } from "vue2-leaflet";
import * as esri from "esri-leaflet";
import "leaflet-kmz/dist/leaflet-kmz";
import "leaflet-kml/L.KML";
import { Icon } from "leaflet";
import EventBus from "../event-bus";


import { styled } from "@egoist/vue-emotion";

const BtnAction = styled("button")`
  color: ${(props) => props.colorT};
  border-color: ${(props) => props.colorT};
  &.bg-selected {
    background-color: ${(props) => props.colorT};
    color: #fff;
  }
  &:hover {
    background-color: ${(props) => props.colorT};
  }
`;

const DivSelectedStyled = styled("div")`
  &.bg-selected {
    background-color: ${(props) => props.colorT};
  }
  &:hover {
    background-color: #d1d5db;
  }
`;

export default {
  mixins: [urlMixin],
  name: "download-list",
  data() {
    return {
      listRegisters: [],
      search: "",
      currentRegister: {},
      list_path_media_folder: null,
      showEventModal: false,
      showingSuccess: false,
      showingConfirm: false,
      showingError: false,
      showingSuccessDelete: false,
      showCommentsModal: false,
      showRaisingModal: false,
      statusFilter: "TODOS",
      email: localStorage.getItem("email"),
      category: window.atob(localStorage.getItem("category")),
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      formOrder: "upward",
      color_principal: "",
      color_secundario: "",
      color_terciario: "",
    };
  },
  components: {
    AlertDialog,
    RaisingModal,
    BtnAction,
    DivSelectedStyled,
  },
  mounted() {
    if (this.$route.query.id && this.$route.query.name) {
      let id = this.$route.query.id.toString();
      let name = this.$route.query.name.toString();
      this.search = `${id} ${name}`;
    }

    EventBus.$emit("updateNotification", {});
    this.fetchRegisters();
  },
  methods: {
    updateselectElement() {
      if (this.filteredRegisters.length > 0) {
        this.selectRegister(this.filteredRegisters[0]);
      }
    },
    fetchRegisters() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/downloads/getListGeneral",
          {
            email: localStorage.getItem("email"),
            category: window.atob(localStorage.getItem("category")),
          },
          this.config
        )
        .then((response) => {
          this.listRegisters = response.data.list;
          //// removed console log
          if (this.filteredRegisters.length > 0) {
            this.selectRegister(this.filteredRegisters[0]);
          }
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        });
    },
    selectRegister(event) {
      this.currentRegister = event;
    },

    changeFormOrder() {
      this.formOrder = this.formOrder === "upward" ? "downward" : "upward";
    },
    updateStatusModal(status, label) {
      this.showRaisingModal = true;
      EventBus.$emit("statusModal", {
        raising_id: this.currentRegister.id,
        status: status,
        label: label,
        menu: "DESCARGAS",
      });
    },
    catchError(error) {
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
    },
    fetchConfiguration() {
      this.axios
        .get("apidev/api/config/site")
        .then((response) => {
          let conf = response.data.config;
          /* this.url_image = conf.url_image; */
          this.color_principal = conf.color_principal;
          this.color_secundario = conf.color_secundario;
          this.color_terciario = conf.color_terciario;
        })
        .catch((error) => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
  },
  computed: {
    filteredRegisters() {
      return this.listRegisters
        .filter((elem) => {
          let date = moment(elem.fecha_solicitud).format("DD/MM/YYYY");
          let new_string_search = `${date.toLowerCase()} ${elem.id.toString()} ${elem.nombre_descarga.toLowerCase()}`;

          switch (this.statusFilter) {
            case "TODOS":
              return new_string_search.includes(this.search.toLowerCase());
            case "RECHAZADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "RECHAZADO"
              );
            case "NO REVISADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "NO REVISADO"
              );
            case "EN REVISIÓN":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "EN REVISIÓN"
              );
            case "APROBADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "APROBADO"
              );
            default:
              break;
          }
        })
        .sort((a, b) => {
          if (this.formOrder === "upward") {
            return new Date(a.fecha_creacion) - new Date(b.fecha_creacion);
          } else {
            return new Date(b.fecha_creacion) - new Date(a.fecha_creacion);
          }
        });
    },
    filteredByAll() {
      return this.listRegisters;
    },
    filteredByOpen() {
      return this.listRegisters.filter((elem) => elem.status == "NO REVISADO");
    },
    filteredByCanceled() {
      return this.listRegisters.filter((elem) => elem.status == "RECHAZADO");
    },
    filteredByAttended() {
      return this.listRegisters.filter((elem) => elem.status == "APROBADO");
    },
  },
  beforeMount() {
    this.fetchConfiguration();
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
